import '@material/web/progress/linear-progress.js';

export class LinearProgressIndicator {
    constructor() {
        this.initialize();
    }

    initialize = () => {
        const linearProgress = document.querySelector('md-linear-progress') as any;
        if (linearProgress) {
            linearProgress.indeterminate = true;
            linearProgress.progress = 0.5;
        }
    }
}